import { makeStyles } from '@material-ui/core';
import logoIcon from './logo-icon.png';

const useStyles = makeStyles({
  img: {
    width: 'auto',
    height: 28,
  },
});

export const LogoIcon = () => {
  const classes = useStyles();
  return <img className={classes.img} src={logoIcon} alt="Goals" />;
};
